import React, { useState } from 'react';
import {
    Grid,
    Typography,
    Button,
    TextField,
    MenuItem,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    TablePagination,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    Checkbox,
    FormControlLabel
} from "@mui/material";
import { NavLink } from "react-router-dom";
import Layout from "../../components/Wrappers/Layout";
// import { AiOutlineSearch } from "react-icons/ai";
import { Card, Alert } from "reactstrap";
import { useDispatch, useSelector } from 'react-redux';
import { useEffect } from 'react';
import success from "../../assets/img/success.png";
import CustomButton from "../../../src/components/CustomButton/CustomButton";

import EditIcon from "@mui/icons-material/Edit";
import VisibilityIcon from "@mui/icons-material/Visibility";
import failed from "../../assets/img/failed.png";
import { adminGetCountryList } from '../../redux/actions/adminGetCountryList';
import { adminAddOrUpdateNewCountryAction } from '../../redux/actions/adminAddOrUpdateNewCountryAction';
import LoadingSpinner from '../../components/LoadingSpinner/LoadingSpinner';
import { makeStyles } from "@mui/styles";
import SOLogout from "../../components/Logout/SOLogout";
import regenerateToken from "../../components/RegenerateToken/regenerateToken";
import { countries } from '../../utils/countriesDropdown';

const useStyles = makeStyles({
    table: {
        minWidth: 650
    }
});

const CountrySettings = () => {

    const [page, setPage] = useState(0);
    const [addCountry, setaddCountry] = useState('');
    const [addCountryCode, setaddCountryCode] = useState('');
    const [addCountryIso, setaddCountryIso] = useState('');
    const [addOpen, setAddOpen] = useState(false);
    const [searchCountry, setsearchCountry] = useState("");
    const [setAddUpdateResp, setsetAddUpdateResp] = useState(false);
    const [notificationOpen, setnotificationOpen] = useState(false);
    const [respDescriptionAddUpdate, setrespDescriptionAddUpdate] = useState('');
    const [isLoading, setisLoading] = useState(false);
    const [rowsPerPage, setRowsPerPage] = useState(5);
    const [countryList, setcountryList] = useState([])
    const [selectedCountry, setselectedCountry] = useState('');
    const [setSearch, setsetSearch] = useState(false);
    const [editOpen, seteditOpen] = useState(false);
    const [editCountryId, seteditCountryId] = useState('');
    const [editCountryName, seteditCountryName] = useState('');
    const [editCountryCode, seteditCountryCode] = useState('');
    const [editCountryIso, seteditCountryIso] = useState('');
    const [allCountries, setallCountries] = useState('');
    const [countriesDropdown, setcountriesDropdown] = useState([]);
    const [tableData, settableData] = useState([]);
    const [addSet, setaddSet] = useState(false);

    const [getCountryName, setetCountryName] = useState([]);


    const handleChangeCountries = e => {
        const name = e.target.name;
        const value = e.target.value;
        if (name === 'allCountries') {
            setallCountries(value);
        }
    }

    const editHandleChange = e => {
        const name = e.target.name;
        const value = e.target.value;
        if (name === 'editCountryId') {
            seteditCountryId(value);
        }
        if (name === 'editCountryName') {
            seteditCountryName(value);
        }
        if (name === 'editCountryCode') {
            seteditCountryCode(value)
        }
        if (name === 'editCountryIso') {
            seteditCountryIso(value)
        }
    }

    const editModal = (id, name, code, iso) => {
        seteditCountryId(id);
        seteditCountryName(name);
        seteditCountryCode(code);
        seteditCountryIso(iso);
        seteditOpen(true);
    }

    const closeEditModal = () => {
        seteditOpen(false);
    }

    const editSubmitFunc = () => {
        setsetAddUpdateResp(true);
        const editReq = {
            actionCustomerMasterRequestVO: {
                walletOwnerId: regenerateTokenRes.data.partnerId,
                id: editCountryId,
                country: editCountryName,
                countryCode: editCountryCode,
                countryIso: editCountryIso
            }
        }
        dispatch(adminAddOrUpdateNewCountryAction(editReq, authToken));
        seteditOpen(false);
    }

    const handleChange = ({ target: { name, value } }) => {
        if (name === "countryList") {
            setselectedCountry(value === "Select Country" ? "" : value);
        }
    };

    const classes = useStyles();

    const regenerateTokenRes = useSelector(({ regenerateToken }) => regenerateToken);
    const addOrUpdateNeCountryRes = useSelector(({ addOrUpdateNeCountry }) => addOrUpdateNeCountry);
    const getCountryListRes = useSelector(({ getCountryList }) => getCountryList);
    // var authToken = regenerateTokenRes.data.AuthToken;
    const dispatch = useDispatch();
    var authToken = regenerateTokenRes.data?.AuthToken; // Use optional chaining for safety

        // Function to fetch the country list
    const fetchCountryList = () => {
        setisLoading(true); // Set loading to true before dispatching the API call
        const req = {
            actionCustomerMasterRequestVO: {
                walletOwnerId: regenerateTokenRes.data?.partnerId, // Use optional chaining
                country: "",
                countryCode: "",
                countryIso: ""
            }
        }
        dispatch(adminGetCountryList(req, authToken));
    };

     // Effect to handle initial load and re-fetching after token regeneration
    useEffect(() => {
        // Only fetch if authToken is available
        if (authToken && regenerateTokenRes.data?.partnerId) {
            fetchCountryList();
        }
    }, [authToken, regenerateTokenRes.data?.partnerId]); // Dependency on authToken and partnerId

    // Effect to handle the response of getCountryListRes
    useEffect(() => {
        if (getCountryListRes.data) {
            if (getCountryListRes.data.status === 'success') {
                setcountryList(getCountryListRes.data.customerMasterDetailsRequestVOList);
                setcountriesDropdown(getCountryListRes.data.customerMasterDetailsRequestVOList); // Also update dropdown
                setisLoading(false);
                searchCountryList(); // Re-apply search filter if any
            } else if (getCountryListRes.data.status === 'failed') {
                setcountryList([]);
                setisLoading(false);
                if (getCountryListRes.data.description === "session out") {
                    SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
                } else if (getCountryListRes.data.description === "Authorization failed") {
                    // Trigger token regeneration if authorization fails
                    dispatch(regenerateToken(regenerateTokenRes.data.partnerId)); // Assuming regenerateToken takes partnerId
                }
            }
        }
    }, [getCountryListRes.data, dispatch, authToken, regenerateTokenRes.data?.partnerId]);


    // const getCountryResp = () => {
    //     if (getCountryListRes.data.status === 'success') {
    //         setcountryList(getCountryListRes.data.customerMasterDetailsRequestVOList);
    //         setisLoading(false);
    //     }
    //     if (getCountryListRes.data.status === 'failed') {
    //         setcountryList([]);
    //         setisLoading(false);
    //         if (
    //             getCountryListRes.data.description == "session out"
    //         ) {
    //             SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
    //         }
    //         if (
    //             getCountryListRes.data.description == "Authorization failed"
    //         ) {
    //             regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
    //         }
    //     }
    // }

    // useEffect(() => {
    //     getCountryResp();
    // }, [getCountryListRes.data.status]);

    const setDropdownCountries = () => {
        if (getCountryListRes.data.status === 'success') {
            console.log("GETCOUNTRY CHECK", getCountryListRes.data.customerMasterDetailsRequestVOList)
            setcountriesDropdown(getCountryListRes.data.customerMasterDetailsRequestVOList);
            searchCountryList();
            setisLoading(false);
        }
        if (getCountryListRes.data.status === 'failed') {
            // setcountriesDropdown(getCountryListRes.data.customerMasterDetailsRequestVOList);
            if (
                getCountryListRes.data.description == "session out"
            ) {
                SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
            }
            if (
                getCountryListRes.data.description == "Authorization failed"
            ) {
                regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
            }
            searchCountryList();
            setisLoading(false);
        }
    }

    useEffect(() => {
        getAllCOuntries()
    }, [countriesDropdown]);


    useEffect(() => {
        setDropdownCountries();
    }, [getCountryListRes.data.status])

    const handleNoticationClose = () => {
        setnotificationOpen(false);
        setrespDescriptionAddUpdate('');
    }

    const addOrUpdateNewCountryRespFunc = () => {
        if (setAddUpdateResp) {
            if (addOrUpdateNeCountryRes.data.status === 'success') {
                setrespDescriptionAddUpdate(addOrUpdateNeCountryRes.data.description);
                setDropdownCountries();
                setnotificationOpen(true);
                fetchCountryList()
                // getCurrencyMasterListReq();
            }
            if (addOrUpdateNeCountryRes.data.status === 'failed') {
                setrespDescriptionAddUpdate(addOrUpdateNeCountryRes.data.description);
                setnotificationOpen(true);
                if (
                    addOrUpdateNeCountryRes.data.description == "session out"
                ) {
                    SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
                }
                if (
                    addOrUpdateNeCountryRes.data.description == "Authorization failed"
                ) {
                    regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
                }
            }
        }
    }

    useEffect(() => {
        addOrUpdateNewCountryRespFunc()
    }, [addOrUpdateNeCountryRes.data.status]);

    // useEffect(() => {
    //     getCurrencyMasterListReq()
    // }, []);

    // const getCurrencyMasterListReq = () => {
    //     const req = {
    //         actionCustomerMasterRequestVO: {
    //             walletOwnerId: regenerateTokenRes.data.partnerId,
    //             country: "",
    //             countryCode: "",
    //             countryIso: ""
    //         }
    //     }
    //     dispatch(adminGetCountryList(req, authToken));
    // };

    const getAllCOuntries = () => {
        if (addSet) {
            if (addOrUpdateNeCountryRes.data.status === 'success') {
                settableData([].concat(getCountryListRes.data.customerMasterDetailsRequestVOList))
            }
            if (addOrUpdateNeCountryRes.data.status === 'failed') {
                // settableData([].concat(getCountryListRes.data.customerMasterDetailsRequestVOList))
                if (
                    addOrUpdateNeCountryRes.data.description == "session out"
                ) {
                    SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
                }
                if (
                    addOrUpdateNeCountryRes.data.description == "Authorization failed"
                ) {
                    regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
                }
            }
        }
        setaddSet(false);
    }


    const searchCountryList = () => {
        setPage(0);
        [].concat(countriesDropdown).length && [].concat(countriesDropdown).filter(ch => ch.countryName == selectedCountry ? ch : '').length == 0 ?
            settableData([].concat(countriesDropdown)) : settableData([].concat(countriesDropdown.filter(ch => ch.countryName == selectedCountry ? ch : '')))
    }

    const addCountryModalOpen = () => {
        setAddOpen(true);
    }

    const handleClose = () => {
        setAddOpen(false);
        setaddCountry('')
        setaddCountryCode('')
        setaddCountryIso('')
    }

    const addUpdateSubmitFunc = () => {
        setaddSet(true);
        setsetAddUpdateResp(true);
        const addOrUpdateReq = {
            actionCustomerMasterRequestVO: {
                walletOwnerId: regenerateTokenRes.data.partnerId,
                id: '',
                country: allCountries.substring(1).split('-')[2],
                countryCode: allCountries.substring(1).split('-')[0],
                countryIso: allCountries.substring(1).split('-')[1]
            }
        }
        dispatch(adminAddOrUpdateNewCountryAction(addOrUpdateReq, authToken));
        setallCountries('');
        setAddOpen(false);
        setselectedCountry('')
    }

    const onInputChange = e => {
        const name = e.target.name;
        const value = e.target.value;
        if (name === 'addCountry') {
            setaddCountry(value);
        }
        if (name === 'addCountryCode') {
            setaddCountryCode(value)
        }
        if (name === 'addCountryIso') {
            setaddCountryIso(value);
        }
    }

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

     // Initial fetch on component mount (if token is already available)
    useEffect(() => {
        if (regenerateTokenRes.data?.AuthToken && regenerateTokenRes.data?.partnerId) {
            fetchCountryList();
        }
    }, [dispatch, regenerateTokenRes.data?.AuthToken, regenerateTokenRes.data?.partnerId]); 

    return (
        <>
            <Layout>
                <Card>
                    <Grid
                        container
                        style={{
                            padding: "10px",
                            marginTop: "1rem",
                            marginLeft: "1rem",
                            gap: "10px",
                            textAlign: "center"
                        }}
                    >
                        <Grid item xs={12} md={4} sm={3} lg={5}></Grid>
                        <Grid item xs={12} md={3} sm={3} lg={3}>
                            <CustomButton
                                style={{
                                    padding: "8px"
                                }}
                                onClick={addCountryModalOpen}
                            >
                                Add New Country
                            </CustomButton>
                        </Grid>
                        <Grid item xs={12} md={3} sm={3} lg={3}>
                            <NavLink to="/index/adminMappingCountry">
                                <CustomButton
                                    style={{
                                        padding: "8px"
                                    }}
                                >
                                    Mapping Country
                                </CustomButton>
                            </NavLink>
                        </Grid>
                    </Grid>

                    <Grid
                        container
                        spacing={2}
                        style={{ padding: "25px", marginTop: "2rem" }}
                    >
                        <Grid item xs={12} sm={12} md={4} lg={4}>
                            <TextField
                                select
                                size="small"
                                color="primary"
                                type="text"
                                variant='standard'
                                label="Country Name"
                                fullWidth={true}
                                name="countryList"
                                value={selectedCountry || ''}
                                onChange={handleChange}
                            >
                                <MenuItem
                                    value="Select Country"
                                    selected="Select Country"
                                >
                                    Select Country
                                </MenuItem>
                                {countriesDropdown &&
                                    [].concat(countriesDropdown).map((x) => (
                                        <MenuItem key={x.id} value={x.countryName}>
                                            {x.countryName}
                                        </MenuItem>
                                    ))}
                            </TextField>
                        </Grid>
                        <Grid item xs={12} sm={12} md={4} lg={4}>
                            <CustomButton
                                style={{
                                    padding: "8px",
                                    margin: "8px 8px"
                                }}
                                variant="contained"
                                onClick={searchCountryList}
                            >
                                Search
                            </CustomButton>
                        </Grid>
                    </Grid>
                </Card>

                {
                    isLoading ? (<LoadingSpinner />) : tableData == undefined || tableData.length == 0 ||
                        !tableData ? (
                        <Card>
                            {/* <Typography variant="body1">Report Table</Typography> */}
                            <Grid
                                container
                                style={{
                                    padding: "10px"
                                }}
                            >
                                <Grid xs={12} sm={12} md={12} lg={12}>
                                    <Typography variant="body1" style={{ fontWeight: "700" }}
                                    className="themeText"
                                    
                                    >
                                        Report Table
                                    </Typography>
                                </Grid>
                                <Grid xs={12} sm={12} md={12} lg={12}>
                                    <Alert
                                        className="my-3 tableHeaderColor"
                                        variant="secondary"
                                        // style={{ color: "white" }}
                                    >
                                        No Records Found!
                                    </Alert>
                                </Grid>
                            </Grid>
                        </Card>
                    ) : (
                        <Card>
                            <Grid
                                container
                                style={{
                                    padding: "10px"
                                }}
                            >
                                <Grid xs={12} sm={12} md={12} lg={12}>
                                    <Typography variant="body1" style={{ fontWeight: "700" }}
                                    className="themeText"
                                    
                                    >
                                        Report Table
                                    </Typography>
                                </Grid>
                                <TableContainer component={Paper} className="text-nowrap my-3">
                                    <Table
                                        className={classes.table}
                                        size="small"
                                        aria-label="a dense table"
                                    >
                                        <TableHead>
                                            <TableRow className='tableHeaderColor'>
                                                <TableCell
                                                    align="center"
                                                    style={{ fontWeight: "bold", color: "white" }}
                                                >
                                                    Country ID
                                                </TableCell>
                                                <TableCell
                                                    align="center"
                                                    style={{ fontWeight: "bold", color: "white" }}
                                                >
                                                    Country Name
                                                </TableCell>
                                                <TableCell
                                                    align="center"
                                                    style={{ fontWeight: "bold", color: "white" }}
                                                >
                                                    Country Code
                                                </TableCell>
                                                <TableCell
                                                    align="center"
                                                    style={{ fontWeight: "bold", color: "white" }}
                                                >
                                                    Country ISO
                                                </TableCell>
                                                <TableCell
                                                    colSpan={2}
                                                    align="center"
                                                    style={{ fontWeight: "bold", color: "white" }}
                                                >
                                                    Action
                                                </TableCell>
                                            </TableRow>
                                        </TableHead>

                                        <TableBody>
                                            {tableData &&
                                                []
                                                    .concat(tableData)
                                                    .slice(
                                                        page * rowsPerPage,
                                                        page * rowsPerPage + rowsPerPage
                                                    )
                                                    .map((row, index) => (
                                                        <TableRow key={index}>
                                                            <TableCell align="center">
                                                                {row.id}
                                                            </TableCell>
                                                            <TableCell align="center">
                                                                {row.countryName}
                                                            </TableCell>
                                                            <TableCell align="center">{row.countryCode}</TableCell>
                                                            <TableCell align="center">{row.countryIso}</TableCell>
                                                            <TableCell align="center">
                                                                <CustomButton
                                                                    style={{
                                                                        padding: "8px"
                                                                    }}
                                                                    onClick={() => editModal(row.id, row.countryName, row.countryCode, row.countryIso)}
                                                                >
                                                                    <EditIcon style={{ color: "#fff" }} />
                                                                </CustomButton>
                                                            </TableCell>
                                                        </TableRow>
                                                    ))}
                                        </TableBody>
                                    </Table>
                                    <TablePagination
                                        rowsPerPageOptions={[5, 10, 25]}
                                        component="div"
                                        count={[].concat(tableData).length}
                                        rowsPerPage={rowsPerPage}
                                        page={page}
                                        onPageChange={handleChangePage}
                                        onRowsPerPageChange={handleChangeRowsPerPage}
                                    />
                                </TableContainer>
                            </Grid>
                        </Card>
                    )
                }

                <div>
                    <Dialog open={addOpen} onClose={handleClose}>
                        <DialogTitle style={{ minWidth: "600px" }}>
                            Add Country
                        </DialogTitle>
                        <DialogContent>
                            {/* <TextField
                                required
                                style={{ marginTop: "10px" }}
                                size="small"
                                color="primary"
                                type="text"
                                label="Country Name"
                                fullWidth={true}
                                name="addCountry"
                                value={addCountry || ""}
                                onChange={onInputChange}
                            ></TextField>
                            <TextField
                                required
                                style={{ marginTop: "10px" }}
                                size="small"
                                color="primary"
                                type="text"
                                label="Country Code"
                                fullWidth={true}
                                name="addCountryCode"
                                value={addCountryCode || ""}
                                onChange={onInputChange}
                            ></TextField>
                            <TextField
                                required
                                style={{ marginTop: "10px" }}
                                size="small"
                                color="primary"
                                type="text"
                                label="Country ISO"
                                fullWidth={true}
                                name="addCountryIso"
                                value={addCountryIso || ""}
                                onChange={onInputChange}
                            ></TextField> */}
                            <TextField
                                select
                                size="small"
                                color="primary"
                                type="text"
                                variant='standard'
                                label="Country Name"
                                fullWidth={true}
                                name="allCountries"
                                value={allCountries || ''}
                                onChange={handleChangeCountries}
                            >
                                <MenuItem
                                    value="Select Country"
                                    selected="Select Country"
                                >
                                    Select Country
                                </MenuItem>
                                {countries &&
                                    [].concat(countries).map((x, index) => (
                                        <MenuItem key={index} value={`${x.dial_code}-${x.code}-${x.label}`}>
                                            {x.label}
                                        </MenuItem>
                                    ))}
                            </TextField>

                        </DialogContent>
                        <DialogActions style={{ padding: "14px" }}>
                            <CustomButton
                                style={{
                                    // backgroundColor: "#fff",
                                    // color: "#000",
                                    padding: "8px"
                                }}
                                onClick={handleClose}
                            >
                                Cancel
                            </CustomButton>
                            <CustomButton
                                style={{
                                    padding: "8px",
                                    width: "60px"
                                }}
                                onClick={addUpdateSubmitFunc}
                            >
                                Save
                            </CustomButton>
                        </DialogActions>
                    </Dialog>
                </div>
                <div>
                    <Dialog open={editOpen} onClose={closeEditModal}>
                        <DialogTitle style={{ minWidth: "600px" }}>
                            Edit Country
                        </DialogTitle>
                        <DialogContent>
                            <TextField
                                required
                                style={{ marginTop: "10px" }}
                                size="small"
                                disabled
                                color="primary"
                                type="text"
                                label="Country Id"
                                variant='standard'
                                fullWidth={true}
                                name="editCountryId"
                                value={editCountryId || ""}
                                onChange={editHandleChange}
                            ></TextField>
                            <TextField
                                required
                                style={{ marginTop: "10px" }}
                                size="small"
                                color="primary"
                                type="text"
                                label="Country Name"
                                variant='standard'

                                fullWidth={true}
                                name="editCountryName"
                                value={editCountryName || ""}
                                onChange={editHandleChange}
                            ></TextField>

                            <TextField
                                style={{ marginTop: "10px" }}
                                size="small"
                                color="primary"
                                type="text"
                                label="Country Code"
                                fullWidth={true}
                                name="editCountryCode"
                                variant='standard'

                                defaultValue={editCountryCode || ""}
                                onChange={editHandleChange}
                            ></TextField>
                            <TextField
                                style={{ marginTop: "10px" }}
                                size="small"
                                color="primary"
                                type="text"
                                label="Country ISO"
                                variant='standard'

                                fullWidth={true}
                                name="editCountryIso"
                                defaultValue={editCountryIso || ""}
                                onChange={editHandleChange}
                            ></TextField>
                        </DialogContent>
                        <DialogActions style={{ padding: "14px" }}>
                            <CustomButton
                                style={{
                                    // backgroundColor: "#fff",
                                    // color: "#000",
                                    padding: "8px"
                                }}
                                onClick={closeEditModal}
                            >
                                Cancel
                            </CustomButton>
                            <CustomButton
                                style={{
                                    padding: "8px",
                                    width: "60px"
                                }}
                                onClick={editSubmitFunc}
                            >
                                Save
                            </CustomButton>
                        </DialogActions>
                    </Dialog>
                </div>
            </Layout>
            {addOrUpdateNeCountryRes.data.status == "success" && (
                <div>
                    <Dialog open={notificationOpen} onClose={handleNoticationClose}>
                        <DialogContent
                            className="text-center"
                            style={{ backgroundColor: "#00b9f51c" }}
                        >
                            <img src={success} alt="" width="100px" className="my-2" />
                        </DialogContent>
                        <DialogContent>
                            <h4
                                style={{ margin: "0", textAlign: "center", fontSize: "15px" }}
                            >
                                {respDescriptionAddUpdate}
                            </h4>
                        </DialogContent>
                        <DialogActions style={{ justifyContent: "center" }}>
                            <Button
                                style={{
                                    margin: "10px 0",
                                    backgroundColor: "#00b9f5",
                                    color: "white"
                                }}
                                variant="contained"
                                onClick={handleNoticationClose}
                            >
                                Ok
                            </Button>
                        </DialogActions>
                    </Dialog>
                </div>
            )}

            {addOrUpdateNeCountryRes.data.status == "failed" && (
                <div>
                    <Dialog open={notificationOpen} onClose={handleNoticationClose}>
                        <DialogContent
                            className="text-center"
                            style={{ backgroundColor: "#00b9f51c" }}
                        >
                            <img src={failed} alt="" width="100px" className="my-2" />
                        </DialogContent>
                        <DialogContent>
                            <h4
                                style={{ margin: "0", textAlign: "center", fontSize: "15px" }}
                            >
                                {respDescriptionAddUpdate}
                            </h4>
                        </DialogContent>
                        <DialogActions style={{ justifyContent: "center" }}>
                            <Button
                                style={{
                                    margin: "10px 0",
                                    backgroundColor: "#00b9f5",
                                    color: "white"
                                }}
                                variant="contained"
                                onClick={handleNoticationClose}
                            >
                                Ok
                            </Button>
                        </DialogActions>
                    </Dialog>
                </div>
            )}
        </>
    )
}

export default CountrySettings